import gql from 'graphql-tag';

export default gql`
query QueryMyHistory(
        $uuidApp: String!,
        $uuidEndpoint: String!
        ) {
    queryMyHistory(
        uuidApp: $uuidApp,
        uuidEndpoint: $uuidEndpoint
    ) {
      items {
        __typename
        uuids
        timestamp
        idRequest
        input
        output
        error
        errorMessage
      }
    }
}
`;
